// Navigation
import Glide from '@glidejs/glide';

$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger'),
        $menuText = $('.hamburger-text');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }

    toggleOpen($menu)

    $($menuText).each(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });
});

// Header submenus: open to the left instead if they'd go past the right edge of the screen.
// Calculated on load/resize (not on hover) so the class is already set before a submenu opens
function alignHeaderSubmenus() {
    let edgeGap = 16;

    $('.header-link-container.has-children').each(function () {
        let $item = $(this);
        let $submenu = $item.children('.header-link-children');

        if (!$submenu.length) {
            return;
        }

        // Measure in the default (left-aligned) position; it's laid out even while hidden
        $item.removeClass('submenu-align-right');

        // The visible edge: the page width without the scrollbar, or the header's edge if that's narrower
        let rightEdge = document.documentElement.clientWidth;
        let header = $item.closest('header')[0];
        if (header) {
            rightEdge = Math.min(rightEdge, header.getBoundingClientRect().right);
        }

        let overflows = $submenu[0].getBoundingClientRect().right > rightEdge - edgeGap;
        $item.toggleClass('submenu-align-right', overflows);
    });
}

let submenuResizeTimer;
$(window).on('load', alignHeaderSubmenus);
$(window).on('resize', function () {
    clearTimeout(submenuResizeTimer);
    submenuResizeTimer = setTimeout(alignHeaderSubmenus, 150);
});

// Web fonts change the menu's width, so re-check once they've loaded
if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(alignHeaderSubmenus);
}

function checkMenu() {
    let $headerNavTitles = $('.nav-title-container');
    let $navParentItems = $('.nav-parent-item');

    // Prevent parent nav item link clicks from navigating if it has children pages
    $navParentItems.children('.nav-title-container').find('a').click(function (e) {
        if ($(this).closest('.nav-parent-item').children('.nav-secondary').length !== 0) {
            e.preventDefault();
        }
    });

    // Prevent link clicks from navigating
    // $headerNavTitles.find('a').click(function (e) {
    //     e.preventDefault();
    // });

    $headerNavTitles.click(function () {
        let $menu = $(this).parent();
        let $target = $menu.children('.nav-secondary');
        let isOpen = $target.hasClass('menu-active');

        // Close all other open menus
        $headerNavTitles.each(function () {
            let $otherMenu = $(this).parent();
            let $otherTarget = $otherMenu.children('.nav-secondary');

            if (!$otherMenu.is($menu) && $otherTarget.hasClass('menu-active')) {
                closeMenu($otherMenu, $otherTarget);
            }
        });

        // Toggle the clicked menu
        if (isOpen) {
            closeMenu($menu, $target);
        } else {
            openMenu($menu, $target);
        }
    });
}

function openMenu($menu, $target) {
    $menu.addClass('active');
    $target.addClass('menu-active');

    $target.css('height', '0');
    requestAnimationFrame(() => {
        $target.css('height', $target[0].scrollHeight + 'px');
    });

    $target.one('transitionend', function () {
        $target.css('height', 'auto'); // let it breathe after animation
    });
}

function closeMenu($menu, $target) {
    $target.css('height', $target[0].scrollHeight + 'px');
    requestAnimationFrame(() => {
        $target.css('height', '0');
    });

    $target.one('transitionend', function () {
        $target.removeAttr('style');
        $menu.removeClass('active');
        $target.removeClass('menu-active');
    });
}

function toggleOpen(menu) {
    let element = menu[0];
    if (!element.classList.contains('menu-active')) {
        // Collapse
        element.style.height = element.scrollHeight + 'px';
        requestAnimationFrame(() => {
            element.style.height = '0';
        });
        element.classList.remove('menu-active');
    } else {
        // Expand
        element.style.height = element.scrollHeight + 'px';
        element.addEventListener('transitionend', () => {
            element.style.height = 'auto'; // let it breathe after animation
        }, {once: true});
        element.classList.add('menu-active');
    }
}

const bindClickable = () => {
    document.querySelectorAll(".clickable").forEach((card) => {
        const link = card.querySelector("a");

        if (link) {
            card.addEventListener("click", () => {
                link.click();
            });
            card.classList.add("ready");
        }
    });
};

// Fees block: highlight the table cells that match the picked filter options.
// Each cell lists the filter option IDs it glows for in data-options. A filter only counts for a cell
// when the cell has at least one of that filter's options (no options for a filter = any of them is fine).
// A cell glows when it has the picked option for every filter that counts, and at least one picked option
const feesFilters = () => {
    document.querySelectorAll(".fees-block").forEach((block) => {
        const form = block.querySelector(".fees-filters");
        const cells = block.querySelectorAll(".fees-cell");

        if (!form || !cells.length) {
            return;
        }

        // Option ID => its filter (the radio group's name)
        const optionFilters = {};
        form.querySelectorAll("input[type=radio]").forEach((input) => {
            if (input.value !== "") {
                optionFilters[input.value] = input.name;
            }
        });

        const update = () => {
            const picked = Array.from(form.querySelectorAll("input[type=radio]:checked"))
                .filter((input) => input.value !== "");

            cells.forEach((cell) => {
                const options = (cell.dataset.options || "").split(" ").filter(Boolean);
                const cellFilters = options.map((id) => optionFilters[id]);
                let matched = 0;
                let failed = false;

                picked.forEach((input) => {
                    if (!cellFilters.includes(input.name)) {
                        return;
                    }

                    if (options.includes(input.value)) {
                        matched++;
                    } else {
                        failed = true;
                    }
                });

                cell.classList.toggle("highlighted", matched > 0 && !failed);
            });
        };

        form.addEventListener("change", update);
        form.addEventListener("submit", (e) => e.preventDefault());
        // The reset event fires before the radios are reset
        form.addEventListener("reset", () => setTimeout(update, 0));

        // Browsers can restore picked radios when going back to the page
        update();
    });
};

function numberCountUp() {
    const $counters = $('.number-count-up');
    const speed = 2000; // total duration in ms

    // helper: check if element is in viewport
    function isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    function animateCounter($el) {
        const targetText = $el.data('target').toString().trim();
        const targetValue = parseInt(targetText.replace(/[^0-9]/g, ''), 10);
        const hasPlus = /\+$/.test(targetText);

        // Skip animation if target is invalid
        if (isNaN(targetValue) || !/^[\d,\s+]+$/.test(targetText)) {
            // console.warn('Invalid target value:', targetText);
            return;
        }

        $({countNum: 0}).animate(
            {countNum: targetValue},
            {
                duration: speed,
                easing: 'swing',
                step: function () {
                    $el.text(Math.floor(this.countNum) + (hasPlus ? '+' : ''));
                },
                complete: function () {
                    $el.text(targetText); // restore full final text
                },
            }
        );
    }

    // trigger on scroll
    function checkCounters() {
        $counters.each(function () {
            const $this = $(this);
            if (!$this.data('animated') && isInViewport(this)) {
                $this.data('animated', true);
                animateCounter($this);
            }
        });
    }

    $(window).on('scroll resize', checkCounters);
    checkCounters(); // check on page load too
}

$(document).stop().on('scroll', function () {
    $('.animate').not('.run').each(function () {
        if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run');
    });

    // $('.animate-1').not('.run').each(function () {
    //     if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run');
    // });
    //
    // setTimeout(function () {
    //     $('.animate-2').not('.run').each(function () {
    //         if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run');
    //     });
    // }, 200);
    //
    // setTimeout(function () {
    //     $('.animate-3').not('.run').each(function () {
    //         if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run');
    //     });
    // }, 400);
    //
    // setTimeout(function () {
    //     $('.animate-4').not('.run').each(function () {
    //         if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run');
    //     });
    // }, 600);
    //
    // setTimeout(function () {
    //     $('.animate-5').not('.run').each(function () {
    //         if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run');
    //     });
    // }, 800);
    //
    // setTimeout(function () {
    //     $('.animate-6').not('.run').each(function () {
    //         if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run');
    //     });
    // }, 1000);
}).trigger('scroll');

function setCookie(cname, cvalue, exdays = null) {
    let expires = "";
    if (exdays !== null) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = "expires=" + d.toUTCString() + ";";
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + "path=/";
}

// Alert bars (inside the sticky header). Closing one hides it and sets a cookie, so it stays hidden
// (for 12 hours, or until the alert is edited - the server compares data-alertcode against the cookie)
function watchAlerts(alertBarsContainer) {
    const alertBars = alertBarsContainer.querySelectorAll('.alert-bar');

    function closeAlert(alertBar) {
        if (alertBar.classList.contains('inactive')) {
            return;
        }

        setCookie('alert-hidden-' + alertBar.dataset.alertkey, alertBar.dataset.alertcode, 0.5);

        // Collapse from the bar's real height (not a large max-height), so the animation starts straight away
        alertBar.style.maxHeight = alertBar.scrollHeight + 'px';
        alertBar.offsetHeight; // force a reflow so the starting height is applied before collapsing
        alertBar.classList.add('inactive');

        let hidden = false;
        function hide() {
            if (hidden) {
                return;
            }
            hidden = true;
            alertBar.style.display = 'none';

            // Remove the wrapper once every alert has been closed
            const anyOpen = Array.from(alertBars).some(function (bar) {
                return bar.style.display !== 'none';
            });
            if (!anyOpen) {
                alertBarsContainer.style.display = 'none';
            }
        }

        alertBar.addEventListener('transitionend', function (event) {
            if (event.target === alertBar && event.propertyName === 'max-height') {
                hide();
            }
        });

        // Fallback in case the transition doesn't run (e.g. reduced motion settings)
        setTimeout(hide, 600);
    }

    alertBars.forEach(function (alertBar) {
        const closeBtn = alertBar.querySelector('.alert-close');

        if (closeBtn) {
            closeBtn.addEventListener('click', function () {
                closeAlert(alertBar);
            });
        }

        // Following a link in the alert also dismisses it
        alertBar.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', function () {
                setCookie('alert-hidden-' + alertBar.dataset.alertkey, alertBar.dataset.alertcode, 0.5);
            });
        });
    });
}

$(document).ready(function () {
    if ($(window).width() <= 680) {
        checkMenu();
    }

    bindClickable();
    numberCountUp();

    if ($('.fees-block').length) {
        feesFilters();
    }

    if ($('.video-gallery-container').length) {
        $('.video-gallery-container').each(function () {
                watchModalVideos($(this));
            }
        );
    }

    if ($('.staff-carousel').length) {
        $('.staff-carousel').each(function () {
            watchStaffCarousel($(this));
        });
    }

    if ($('.carousel-images-container').length) {
        $('.carousel-images-container').each(function () {
            watchImageCarousel($(this));
        });
    }

    if ($('.vid-container').length) {
        // AblePlayer will auto-initialize elements with data-able-player attribute
        // But you can also manually initialize:
        setTimeout(function () {
            $($('.vid-container')).each(function () {
                if ($(this).hasClass('inactive')) {
                    $(this).removeClass('inactive');
                }

                let $video = $(this).find('video[data-able-player]');
                new AblePlayer($video);
            });
        }, 2000);

        $($('.vid-container')).each(function () {

            let container = $(this);
            let toggler = $(this).find('.toggle-checkbox');
            let YTContainer = $(this).find('.yt-player');
            let AblePlayer = $(this).find('.able-video');

            toggler.on('change', function () {
                let status = $(this).is(':checked');

                // Update status text
                container.find('.toggle-status').text(status ? 'Able Player' : 'YouTube Player');

                if (status) {
                    if (!YTContainer.hasClass('hidden')) {
                        YTContainer.addClass('hidden');
                    }

                    if (AblePlayer.hasClass('hidden')) {
                        AblePlayer.removeClass('hidden');
                    }
                } else {
                    if (YTContainer.hasClass('hidden')) {
                        YTContainer.removeClass('hidden');
                    }

                    if (!AblePlayer.hasClass('hidden')) {
                        AblePlayer.addClass('hidden');
                    }
                }
            });
        });
    }

    if ($('form').length) {
        let $errText = $('form').find('input.input.phone.text').siblings('#phone-format-error').text();

        $('form').find('input.input.phone.text').on('input', function () {
            const value = $(this).val();
            const validPattern = /^[0-9+\-\s()]*$/;
            let $errField = $(this).siblings('#phone-format-error');

            if (validPattern.test(value)) {
                $errField.css('display', 'none');
            } else {
                const cleaned = value.replace(/[^0-9+\-\s()]/g, '');
                $(this).val(cleaned);
                $errField.css('display', 'unset');

                if ($errField.text().trim() === '') {
                    $($errField).text($errText);
                }
            }
        });
    }

    if ($('.faq-lists-container').length) {
        $('.faq-lists-container').each(function () {
            watchFAQList($(this));
        });
    }

    const alertBarsContainer = document.querySelector('.alert-bars');
    if (alertBarsContainer) {
        watchAlerts(alertBarsContainer);
    }
});

function watchFAQList($faqListContainer) {
    let $faqLists = $faqListContainer.find('.faq-list');

    $($faqLists).each(function () {
        let $faqs = $(this).find('.faq');

        $faqs.find('.faq-top, .faq-content').on('click', function (e) {
            if ($(e.target).is('a')) return;
            e.preventDefault();

            const $details = $(this).closest('details');
            const $content = $details.find('.faq-content');
            const isOpen = $details.attr('open') !== undefined;
            const $list = $details.closest('.faq-list'); // scope to this FAQ's own list

            if ($details.hasClass('always-open')) {
                return;
            }

            if (isOpen) {
                $content.slideUp(400, function () {
                    $details.removeAttr('open');
                });
            } else {
                // close any other open FAQ in the same list first
                $list.find('details[open]').not($details).each(function () {
                    const $other = $(this);
                    $other.find('.faq-content').slideUp(400, function () {
                        $other.removeAttr('open');
                    });
                });

                $details.attr('open', true);
                $content.hide().slideDown(400);
            }
        });
    });
}

function watchImageCarousel($glide) {
    let $glideEle = $glide.children('.main-gallery-container')[0];
    let $targetCog = $glide.parent();

    if (!$glideEle) {
        return;
    }

    let slideCount = $($glideEle).find('.glide__slide').length;

    // 'slider' (not 'carousel') so Glide doesn't clone slides - clones aren't wired up to the lightbox
    let $mainGlide = new Glide($glideEle, {
        type: "carousel",
        bound: true,
        rewind: true,
        // Mouse drag + touch swipe. Glide blocks the lightbox click after a drag, so dragging won't open it
        dragThreshold: 80,
        swipeThreshold: 60,
        gap: 24,
        perView: Math.min(3, slideCount),
        breakpoints: {
            992: {
                perView: Math.min(2, slideCount),
            },
            680: {
                perView: 1,
            },
        }
    });

    window.setTimeout(function () {
        $mainGlide.mount();
    }, 1000)

    // Update the Glide for image resizing + take away loading cog
    window.setTimeout(function () {
        $mainGlide.update();

        if ($targetCog.hasClass('inactive')) {
            $targetCog.removeClass('inactive');
        }

    }, 1250)
}

function watchStaffCarousel($glide) {
    let $glideID = $glide.attr('id');
    let $glideEle = $(`#${$glideID}`)[0];

    let $thisGlide = new Glide($glideEle, {
        type: "carousel",
        perView: 3,
        keyboard: true,
        gap: 32,
        breakpoints: {
            1024: {perView: 2},
            600: {perView: 1}
        }
    }).mount();

    window.setTimeout(function () {
        $thisGlide.update();
    }, 1250)
}

function watchModalVideos($videoGalleryContainer) {
    let $videoItems = $videoGalleryContainer.find('.video-gallery-item');
    let $videoModals = $videoGalleryContainer.find('.modal-video-container');
    let $overlay = $videoGalleryContainer.find('.video-background');

    $($videoItems).on('click', function (e) {
        let $target = $(this).attr('data-modal-id');
        $overlay.addClass('active');

        $videoModals.each(function () {
            $(this).removeClass('active');

            if ($(this).data('video-id') === $target) {
                $(this).addClass('active');
            }
        });

        // let $video = $(this).find('video[data-able-player]');
        // new AblePlayer($video);
    });

    $overlay.on('click', function (e) {
        $overlay.removeClass('active');
        $videoModals.removeClass('active');

        $($videoModals).each(function () {
            let $VimeoPlayer = new Vimeo.Player($(this).find('iframe'));
            $VimeoPlayer.pause();
        });
    });
}
